import Vue from 'vue'
// import './sentry';
import "./vuetify";
import "./designSystem";
// import "./i18n";
import TranslationPlugin from "./vcita-i18n";
import store from '../store/store'
import AnalyticsPlugin from './analytics'
import LoggerPlugin from "./logger"
import FeaturesPlugin from './features'
import FrontageApiPlugin from "./frontage-api";
import PermissionsPlugin from './permissions'
import './vue-resize'
import VueDeprecate from 'vue-deprecate';
import Editor from './tinymce/tinymceInstant.js';
import devices from './devices';

Vue.use(VueDeprecate);

Vue.use(FeaturesPlugin, {store});
Vue.use(AnalyticsPlugin);
Vue.use(LoggerPlugin);
Vue.use(TranslationPlugin, {store});
Vue.use(FrontageApiPlugin);
Vue.use(PermissionsPlugin);

Vue.component('Editor', Editor);

devices.addToVueInstance(Vue);
